module.exports = __webpack_public_path__ + "img/safari.ccf94764.svg";